var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle124(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "275.91742939957214 384.81701980309333 15.085705232401153 15.644259593518882",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M287,392.61c-.08,2.03-1.66,3.8-3.46,3.85-1.9.06-3.7-2-3.62-4.15.08-2.03,1.71-3.57,3.7-3.49,2,.08,3.46,1.72,3.38,3.79Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle124);
export default __webpack_public_path__ + "static/media/twinkle-1-24.8ee2ac8963af1c67831ac3982ce7324e.svg";
export { ForwardRef as ReactComponent };